<div class="container">
  <div class="header">
    <h2 mat-dialog-title>{{ 'MENU_EDIT.MODIFIER_GROUP' | translate }}</h2>
    <button mat-icon-button mat-dialog-close aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'MENU.NAME' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="mgName" required>
      </mat-form-field>
    </div>

    <div *ngFor="let lang of data.organization.additionalLanguages ?? []" class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'MENU.NAME' | translate }} ({{lang}})</mat-label>
        <input matInput type="text" [(ngModel)]="nameTranslations[lang]">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'MENU.DESCRIPTION' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="description">
      </mat-form-field>
    </div>

    <div *ngFor="let lang of data.organization.additionalLanguages ?? []" class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'MENU.DESCRIPTION' | translate }} ({{lang}})</mat-label>
        <input matInput type="text" [(ngModel)]="descriptionTranslations[lang]">
      </mat-form-field>
    </div>

    <div class="modifiers-section" *ngIf="modifierProducts.length > 0">
      <h3>{{ 'MENU.MODIFIERS' | translate }}</h3>
      <div class="modifiers-list">
        <div class="modifier-tag" *ngFor="let modifier of modifierProducts">
          {{GetModifierName(modifier.modifierId)}}
        </div>
      </div>
    </div>

    <div class="actions">
      <button mat-button (click)="onClickSelectModifiers()">
        {{ 'MENU.SELECT_MODIFIERS' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="onSubmit()">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
